import { render, staticRenderFns } from "./TaskItemBottom.vue?vue&type=template&id=0cd1983e"
import script from "./TaskItemBottom.vue?vue&type=script&lang=js"
export * from "./TaskItemBottom.vue?vue&type=script&lang=js"
import style0 from "./TaskItemBottom.vue?vue&type=style&index=0&id=0cd1983e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports